<template>
    <link-dialog v-model="p_show"
                 dialog-class="link-address-modal"
                 :title="title"
                 confirm-button
                 cancel-button
                 @confirm="handleConfirm"
                 @cancel="handleCancel"
    >
        <div class="link-address-modal-content">
            <link-address-modal-item :list="provinces" :value="address.province" :mutiple="mutiple" @input="val=>handleClick(val,'province')" @confirm="()=>$nextTick(()=>handleConfirm())" :title="$t('LinkForm.province')"
                                     v-show="types.indexOf('province')>-1"/>
            <link-address-modal-item :list="cities" :value="address.city" :mutiple="mutiple" @input="val=>handleClick(val,'city')" @confirm="()=>$nextTick(()=>handleConfirm())" :title="$t('LinkForm.city')"
                                     v-show="types.indexOf('city')>-1"/>
            <link-address-modal-item :list="districts" :value="address.district" :mutiple="mutiple" @input="val=>handleClick(val,'district')" @confirm="()=>$nextTick(()=>handleConfirm())" :title="$t('LinkForm.district')"
                                     v-show="types.indexOf('district')>-1"/>
        </div>
    </link-dialog>
</template>

<script>
    import LinkAddressModalItem from "./link-address-modal-item";

    const DEFAULT_OPTION = {
        types: ['province', 'city', 'district'],
        param: {},
        title: null,
        onConfirm: null,
        onCancel: null,
    }

    /**
     * 地址选择模态框
     * @author  韦胜健
     * @date    2018/12/3 10:07
     */
    export default {
        name: 'link-address-modal',
        components: {LinkAddressModalItem},
		props: {
			mutiple: {type: Boolean, default: false},                                                      // 是否多选
			isDefault: {type: Boolean, default: true},                                                     // 是否设置默认值
		},
        watch: {
            param(val) {
                Object.assign(this.address, val)
                this.resetAddress()
            }
        },
        data() {
            return {
                p_show: false,
                addressData: null,                                                                      // 省市县地址数据
                address: Object.assign({province: null, city: null, district: null}, this.param),       // 当前省市县值
                initialized: false,                                                                     //当前是否已经初始化数据

                ...this.$lv.$utils.deepCopy(DEFAULT_OPTION),
                title: LinkVue.$t('LinkForm.pickAddress'),
            };
        },
        async created() {
            this.addressData = await this.$lv.$address.getAddress(this)
            this.resetAddress()
            this.initialized = true;
        },
        computed: {
            /**
             * 省份列表数据
             * @author  韦胜健
             * @date    2018/12/3 11:34
             */
            provinces() {
                return !this.initialized ? [] : Object.keys(this.addressData || {})
            },
            /**
             * 城市列表数据
             * @author  韦胜健
             * @date    2018/12/3 11:34
             */
            cities() {
                return !this.initialized ? [] : Object.keys(!!this.addressData && !!this.addressData[this.address.province] ? this.addressData[this.address.province] : {})
            },
            /**
             * 区县列表数据
             * @author  韦胜健
             * @date    2018/12/3 11:34
             */
            districts() {
                return !this.initialized ? [] : Object.keys(!!this.addressData && !!this.addressData[this.address.province] && !!this.addressData[this.address.province][this.address.city] ? this.addressData[this.address.province][this.address.city] : {})
            },
        },
        methods: {
            /**
             * 重新初始化省市县值，因为是联动数据，所以选择父值的时候，需要重置子值
             * @author  韦胜健
             * @date    2018/12/3 11:35
             */
            resetAddress() {
				if (!this.addressData) return
                this.address.province = this.address.province || (this.isDefault ? Object.keys(this.addressData)[0] : '')
                if(!!this.address.province) this.address.city = this.address.city || (this.isDefault ? Object.keys(this.addressData[this.address.province])[0] : '')
                if(!!this.address.city) this.address.district = this.address.district || (this.isDefault ? Object.keys(this.addressData[this.address.province][this.address.city])[0] : '')
            },
            /**
             * 处理省市县点击事件
             * @author  韦胜健
             * @date    2018/12/3 11:35
             */
            handleClick(val, type) {
                this.address[type] = val
                switch (type) {
                    case 'province':
                        Object.assign(this.address, {city: null, district: null})
                        break
                    case 'city':
                        Object.assign(this.address, {district: null})
                }
                this.resetAddress()
            },
            handleConfirm() {
                const ret = {}
                this.types.forEach(type => ret[type] = this.address[type])
                !!this.onConfirm && this.onConfirm(ret)
                if (!!this.p_show) this.p_show = false
            },
            handleCancel() {
                !!this.onCancel && this.onCancel()
                if (!!this.p_show) this.p_show = false
            },

            pick(option) {
                Object.assign(this, this.$lv.$utils.deepCopy(DEFAULT_OPTION), option)
                this.p_show = true
            },
        },
    };
</script>

<style lang="scss">
    .link-address-modal {
        .link-justify-wrapper {
            font-size: 13px;
        }
    }
</style>
